/**
 * @description Get srcset by ratio
 * @param {Number} ratio
 * @returns {Array} Srcset
 */
export const getSrcSetByRatio = (ratio) => {
  if (ratio < 0.3) {
    return [
      {
        width: '1430',
        media: '(min-width: 1200px)',
        mode: 'crop'
      },
      {
        width: '1200',
        media: '(min-width: 992px)',
        mode: 'crop'
      },
      {
        width: '768',
        media: '(min-width: 768px)',
        mode: 'crop'
      },
      {
        width: '576px',
        media: '(min-width: 576px)',
        mode: 'crop'
      },
      {
        width: '576px',
        media: '(min-width: 0px)',
        mode: 'crop'
      }
    ];
  }

  if (ratio <= 0.75 && ratio >= 0.74) {
    return [
      {
        width: '960',
        height: '714',
        media: '(min-width: 1200px)',
        mode: 'crop'
      },
      {
        width: '600',
        height: '446',
        media: '(min-width: 992px)',
        mode: 'crop'
      },
      {
        width: '496',
        height: '369',
        media: '(min-width: 768px)',
        mode: 'crop'
      },
      {
        width: '714',
        height: '714',
        media: '(min-width: 576px)',
        mode: 'crop'
      },
      {
        width: '576',
        height: '576',
        media: '(min-width: 0px)',
        mode: 'crop'
      }
    ];
  }

  if (ratio > 1.2 && ratio < 1.5) {
    return [
      {
        width: '445',
        height: '549',
        media: '(min-width: 1200px)',
        mode: 'crop'
      },
      {
        width: '400',
        height: '494',
        media: '(min-width: 992px)',
        mode: 'crop'
      },
      {
        width: '331',
        height: '409',
        media: '(min-width: 768px)',
        mode: 'crop'
      },
      {
        width: '445',
        height: '445',
        media: '(min-width: 576px)',
        mode: 'crop'
      },
      {
        width: '445',
        height: '445',
        media: '(min-width: 0px)',
        mode: 'crop'
      }
    ];
  }

  return [
    {
      width: '1430',
      height: '953',
      media: '(min-width: 1200px)',
      mode: 'crop'
    },
    {
      width: '1200',
      height: '800',
      media: '(min-width: 992px)',
      mode: 'crop'
    },
    {
      width: '992',
      height: '661',
      media: '(min-width: 768px)',
      mode: 'crop'
    },
    {
      width: '768',
      height: '512',
      media: '(min-width: 576px)',
      mode: 'crop'
    },
    {
      width: '576',
      height: '384',
      media: '(min-width: 0px)',
      mode: 'crop'
    }
  ];
};

const anchorOptions = [
  null,
  'topleft',
  'topcenter',
  'topright',
  'middleleft',
  'middlecenter',
  'middleright',
  'bottomleft',
  'bottomcenter',
  'bottomright'
];

export const getSourceMediaSets = (orien, anchorIdx, autoCrop, length, width, height) => {
  const anchorMode = anchorOptions[anchorIdx];

  const responsiveSets = {
    'orientation-landscape': {
      '(min-width: 1200px)': {
        baseWidth: 1430,
        ratio: [16 / 9, 3 / 2, 11 / 10]
      },
      '(min-width: 992px)': {
        baseWidth: 1200,
        ratio: [16 / 9, 3 / 2, 11 / 10]
      },
      '(min-width: 768px)': {
        baseWidth: 992,
        ratio: [16 / 9, 3 / 2, 11 / 10]
      },
      '(min-width: 576px)': {
        baseWidth: 768,
        ratio: [16 / 9, 3 / 2, 11 / 10]
      },
      '(min-width: 0px)': {
        baseWidth: 576,
        ratio: [16 / 9, 3 / 2, 11 / 10]
      }
    },
    'orientation-portrait': {
      '(min-width: 1200px)': {
        baseWidth: 1430,
        ratio: [4 / 5, 4 / 5, 4 / 5]
      },
      '(min-width: 992px)': {
        baseWidth: 1200,
        ratio: [4 / 5, 4 / 5, 4 / 5]
      },
      '(min-width: 768px)': {
        baseWidth: 992,
        ratio: [4 / 5, 4 / 5, 4 / 5]
      },
      '(min-width: 576px)': {
        baseWidth: 768,
        ratio: [4 / 5, 4 / 5, 4 / 5]
      },
      '(min-width: 0px)': {
        baseWidth: 576,
        ratio: [4 / 5, 4 / 5, 4 / 5]
      }
    }
  };

  const layoutSets = responsiveSets[orien];
  const mediaResolutions = Object.keys(layoutSets).map((media) => {
    if (orien === 'orientation-landscape') {
      const smallScreen = ['(min-width: 576px)', '(min-width: 0px)'].includes(media);
      const width1x = Math.floor(layoutSets[media].baseWidth / (smallScreen ? 1 : length));
      const height1x = Math.floor(width1x / layoutSets[media].ratio[length - 1]);
      const width2x = Math.min(width1x * 2, width);
      const height2x = Math.floor(width2x / layoutSets[media].ratio[length - 1]);

      return {
        media,
        srcSet: [
          `format=jpg&width=${width1x}&quality=75${autoCrop ? `&height=${height1x}` : ''}${
            autoCrop ? '&mode=crop' : ''
          }${autoCrop ? `&anchor=${anchorMode}` : ''}`,
          `format=jpg&width=${width2x}&quality=40${autoCrop ? `&height=${height2x}` : ''}${
            autoCrop ? '&mode=crop' : ''
          }${autoCrop ? `&anchor=${anchorMode}` : ''} 2x`
        ]
      };
    } else {
      const smallScreen = ['(min-width: 576px)', '(min-width: 0px)'].includes(media);
      const width1x = Math.floor(layoutSets[media].baseWidth / (smallScreen ? 1 : length));
      const height1x = Math.floor(width1x / layoutSets[media].ratio[length - 1]);
      let width2x = Math.min(width1x * 2, width);
      let height2x = Math.floor(width2x / layoutSets[media].ratio[length - 1]);
      if (height2x > height) {
        height2x = height;
        width2x = height * layoutSets[media].ratio[length - 1];
      }

      return {
        media,
        srcSet: [
          `format=jpg&width=${width1x}&quality=75${autoCrop ? `&height=${height1x}` : ''}${
            autoCrop ? '&mode=crop' : ''
          }${autoCrop ? `&anchor=${anchorMode}` : ''}`,
          `format=jpg&width=${width2x}&quality=40${autoCrop ? `&height=${height2x}` : ''}${
            autoCrop ? '&mode=crop' : ''
          }${autoCrop ? `&anchor=${anchorMode}` : ''} 2x`
        ]
      };
    }
  });

  return mediaResolutions;
};

export const getContactCardMediaSets = (length, width, height) => {
  const responsiveSets = {
    '(min-width: 1200px)': {
      baseWidth: [954, 715, 477],
      ratio: [16 / 9, 4 / 3, 4 / 5]
    },
    '(min-width: 992px)': {
      baseWidth: [800, 715, 800],
      ratio: [16 / 9, 4 / 3, 4 / 5]
    },
    '(min-width: 768px)': {
      baseWidth: [661, 496, 661],
      ratio: [16 / 9, 3 / 2, 4 / 5]
    },
    '(min-width: 576px)': {
      baseWidth: [768, 768, 768],
      ratio: [1, 1, 1]
    },
    '(min-width: 0px)': {
      baseWidth: [576, 576, 576],
      ratio: [1, 1, 1]
    }
  };

  const layoutSets = responsiveSets;
  const mediaResolutions = Object.keys(layoutSets).map((media) => {
    let hasOverflow = false;
    let width1x = Math.floor(layoutSets[media].baseWidth[length - 1]);
    let realWidth = Math.min(width1x, width);
    let height1x = Math.floor(realWidth / layoutSets[media].ratio[length - 1]);
    if (height1x > height) {
      height1x = height;
      realWidth = layoutSets[media].ratio[length - 1] * height;
      hasOverflow = true;
    }

    const srcSet = [`format=jpg&width=${realWidth}&quality=75&height=${height1x}&mode=crop`];
    if (width1x < width && !hasOverflow) {
      const width2x = Math.min(width1x * 2, width);
      const height2x = Math.floor(width2x / layoutSets[media].ratio[length - 1]);
      srcSet.push(`format=jpg&width=${width2x}&quality=40&height=${height2x}&mode=crop 2x`);
    }

    return {
      media,
      srcSet
    };
  });

  return mediaResolutions;
};

export const getHeaderMenuMediaItem = (width, height, length = 3) => {
  const responsiveSets = {
    '(min-width: 1200px)': {
      baseWidth: 1430,
      ratio: [1200 / 497, 16 / 9, 16 / 9]
    },
    '(min-width: 992px)': {
      baseWidth: 400,
      ratio: [1200 / 497, 16 / 9, 16 / 9]
    },
    '(min-width: 768px)': {
      baseWidth: 331,
      ratio: [1200 / 497, 16 / 9, 16 / 9]
    },
    '(min-width: 576px)': {
      baseWidth: 768,
      ratio: [1, 1, 2 / 1]
    },
    '(min-width: 0px)': {
      baseWidth: 576,
      ratio: [1, 1, 2 / 1]
    }
  };

  const layoutSets = responsiveSets;
  const mediaResolutions = Object.keys(layoutSets).map((media) => {
    let hasOverflow = false;
    const smallScreen = ['(min-width: 576px)', '(min-width: 0px)'].includes(media);
    let width1x = Math.floor(layoutSets[media].baseWidth / (smallScreen ? 1 : length));
    let realWidth = Math.min(width1x, width);
    let height1x = Math.floor(realWidth / layoutSets[media].ratio[length - 1]);
    if (height1x > height) {
      height1x = height;
      realWidth = layoutSets[media].ratio[length - 1] * height;
      hasOverflow = true;
    }

    const srcSet = [`format=jpg&width=${realWidth}&quality=75&height=${height1x}&mode=crop`];
    if (width1x < width && !hasOverflow) {
      const width2x = Math.min(width1x * 2, width);
      const height2x = Math.floor(width2x / layoutSets[media].ratio[length - 1]);
      srcSet.push(`format=jpg&width=${width2x}&quality=40&height=${height2x}&mode=crop 2x`);
    }

    return {
      media,
      srcSet
    };
  });

  return mediaResolutions;
};

export const getHeroCardMediaSets = (anchorIdx, length, width, height, fullBleed = false) => {
  const anchorMode = anchorOptions[anchorIdx];

  const responsiveSets = {
    '(min-width: 1200px)': {
      baseWidth: 1430,
      ratio: [992 / 388, 715 / 573, 477 / 589]
    },
    '(min-width: 992px)': {
      baseWidth: 1200,
      ratio: [992 / 388, 715 / 573, 477 / 589]
    },
    '(min-width: 768px)': {
      baseWidth: 992,
      ratio: [992 / 388, 715 / 573, 477 / 589]
    },
    '(min-width: 576px)': {
      baseWidth: 768,
      ratio: [1, fullBleed ? 715 / 573 : 1, fullBleed ? 2 / 3 : 1]
    },
    '(min-width: 0px)': {
      baseWidth: 576,
      ratio: [fullBleed ? 2 / 3 : 1, fullBleed ? 2 / 3 : 1, fullBleed ? 2 / 3 : 1]
    }
  };

  const layoutSets = responsiveSets;
  const mediaResolutions = Object.keys(layoutSets).map((media) => {
    const smallScreen = ['(min-width: 576px)', '(min-width: 0px)'].includes(media);
    const width1x = Math.floor(layoutSets[media].baseWidth / (smallScreen ? 1 : length));
    let realWidth = Math.min(width1x, width);
    const height1x = Math.floor(realWidth / layoutSets[media].ratio[length - 1]);

    const srcSet = [`format=jpg&width=${realWidth}&quality=75&height=${height1x}&mode=crop&anchor=${anchorMode}`];

    if (realWidth < width) {
      let width2x = Math.min(realWidth * 2, width);
      let height2x = Math.floor(width2x / layoutSets[media].ratio[length - 1]);
      if (height2x > height) {
        height2x = height;
        width2x = Math.floor(height2x * layoutSets[media].ratio[length - 1]);
      }
      srcSet.push(`format=jpg&width=${width2x}&quality=40&height=${height2x}&mode=crop&anchor=${anchorMode} 2x`);
    }
    // const width2x = Math.min(realWidth * 2, width);
    // const height2x = Math.floor(realWidth / layoutSets[media].ratio[length - 1]);

    return {
      media,
      srcSet: srcSet
    };
  });

  return mediaResolutions;
};

export const getCardImageMediaSets = (length, width, height) => {
  const responsiveSets = {
    '(min-width: 1200px)': {
      baseWidth: 1430,
      ratio: [4 / 3, 892 / 714, 11 / 10, 11 / 10]
    },
    '(min-width: 992px)': {
      baseWidth: 1200,
      ratio: [4 / 3, 892 / 714, 11 / 10, 11 / 10]
    },
    '(min-width: 768px)': {
      baseWidth: 992,
      ratio: [4 / 3, 892 / 714, 11 / 10, 11 / 10]
    },
    '(min-width: 576px)': {
      baseWidth: 768,
      ratio: [4 / 3, 892 / 714, 11 / 10, 11 / 10]
    },
    '(min-width: 0px)': {
      baseWidth: 576,
      ratio: [4 / 3, 892 / 714, 11 / 10, 11 / 10]
    }
  };

  const layoutSets = responsiveSets;
  const mediaResolutions = Object.keys(responsiveSets).map((media) => {
    let hasOverflow = false;
    const width1x = Math.floor(layoutSets[media].baseWidth);
    let realWidth = Math.min(width1x, width);
    let height1x = Math.floor(realWidth / layoutSets[media].ratio[length - 1]);

    if (height1x > height) {
      height1x = height;
      realWidth = Math.floor(layoutSets[media].ratio[length - 1] * height);
      hasOverflow = true;
    }

    const srcSet = [`format=jpg&width=${realWidth}&height=${height1x}&mode=crop`];

    if (realWidth < width && !hasOverflow) {
      let width2x = Math.min(realWidth * 2, width);
      let height2x = Math.floor(width2x / layoutSets[media].ratio[length - 1]);
      if (height2x > height) {
        height2x = height;
        width2x = Math.floor(height2x * layoutSets[media].ratio[length - 1]);
      }
      srcSet.push(`format=jpg&width=${width2x}&height=${height2x}&mode=crop 2x`);
    }
    return {
      media,
      srcSet: srcSet
    };
  });

  return mediaResolutions;
};

export const getCardSliderMediaSets = (width, height, orien) => {
  const ratioSets = {
    'orientation-landscape': 3 / 2,
    'orientation-portrait': 159 / 199,
    'orientation-square': 1
  };
  const responsiveSets = {
    '(min-width: 1200px)': {
      baseWidth: 1430,
      ratio: ratioSets[orien]
    },
    '(min-width: 992px)': {
      baseWidth: 1200,
      ratio: ratioSets[orien]
    },
    '(min-width: 768px)': {
      baseWidth: 992,
      ratio: ratioSets[orien]
    },
    '(min-width: 576px)': {
      baseWidth: 768,
      ratio: ratioSets[orien]
    },
    '(min-width: 0px)': {
      baseWidth: 576,
      ratio: ratioSets[orien]
    }
  };

  const layoutSets = responsiveSets;
  const mediaResolutions = Object.keys(layoutSets).map((media) => {
    let hasOverflow = false;
    let width1x = Math.floor(layoutSets[media].baseWidth);
    let realWidth = Math.min(width1x, width);
    let height1x = Math.floor(realWidth / layoutSets[media].ratio);
    if (height1x > height) {
      height1x = height;
      realWidth = Math.floor(layoutSets[media].ratio * height);
      hasOverflow = true;
    }

    const srcSet = [`format=jpg&width=${realWidth}&quality=75&height=${height1x}&mode=crop`];
    if (width1x < width && !hasOverflow) {
      let width2x = Math.min(width1x * 2, width);
      let height2x = Math.floor(width2x / layoutSets[media].ratio);
      if (height2x > height) {
        height2x = height;
        width2x = Math.floor(height2x * layoutSets[media].ratio);
      }
      srcSet.push(`format=jpg&width=${width2x}&quality=40&height=${height2x}&mode=crop 2x`);
    }

    return {
      media,
      srcSet
    };
  });

  return mediaResolutions;
};
